
























































import { Component, Vue } from "vue-property-decorator";
import Card from "./Card.vue";

@Component({ components: { Card } })
export default class LoginForm extends Vue {
  emailAddress = "";
  send = false;
  success: boolean = false;
  loading = false;

  reset() {
    this.send = false;
    this.success = false;
  }

  postRequestMagicLink(emailAddress: string) {
    return require("modules/base/api").postRequestMagicLink(emailAddress);
  }

  async login() {
    this.loading = true;
    try {
      await this.postRequestMagicLink(this.emailAddress);
      this.success = true;
    } catch (e) {
      this.success = false;
    }
    this.send = true;
    this.loading = false;
  }
}
